export enum MarketingPrices {
  exp_dp = 'exp_dp',
  exp_tx = 'exp_tx',
  trv_dp = 'trv_dp',
  trv_bp = 'trv_bp'
}
